import React from "react";
import "@/App.css";
import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { ProductsSection } from "@/components/ProductsSection";
import { WhyChooseUsSection } from "@/components/WhyChooseUsSection";
import { BrandsSection } from "@/components/BrandsSection";
import { ProcessSection } from "@/components/ProcessSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { WholesaleCTASection } from "@/components/WholesaleCTASection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Navigation />
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <WhyChooseUsSection />
      <BrandsSection />
      <ProcessSection />
      <TestimonialsSection />
      <WholesaleCTASection />
      <ContactSection />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
